import { isLocalhost } from '../../utils/is-localhost';

// Check from the window object if the app is running on localhost (only in browser)
const isLocalhostEnv = typeof window !== 'undefined' ? isLocalhost(window.location.hostname) : false;

// Set the redirect URLs based on the environment
const redirectSignInUrl = isLocalhostEnv ? 'http://localhost:4200/auth-callback' : 'https://tdp-ui.dev.testdatenplattform.draexlmaier.solutions/auth-callback';
const redirectSignOutUrl = isLocalhostEnv ? 'http://localhost:4200/public' : 'https://tdp-ui.dev.testdatenplattform.draexlmaier.solutions/public';

// const will be used later for aws amplify configuration within the development environment
export const envConfig = {
    isProd: false,
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_X4HhGn7Ek',
    userPoolIdExternal: 'eu-central-1_jQNNxJAoj',
    userPoolClientId: '7tukso18cjbrblk8e4n5ssbv54',
    identityPoolId: 'eu-central-1:cc6e6e6d-698f-4638-9232-bb1dfeaf1128',
    cognitoDomain: 'drx-testdataplatform-ui-dev',
    s3BucketName: 'stob-awseur-dataexchange-backend-exchangedata',
    s3BucketNameValidatedProject: 'stob-awseur-dataexchange-backend-validatedproject',
    apiUrl: 'https://tdp-ui-api.tdp.dev.testdatenplattform.draexlmaier.solutions',
    redirectSignIn: redirectSignInUrl,
    redirectSignOut: redirectSignOutUrl,
}

